import {
	FinancialServicesUIProvider,
	RedirectHandler,
	ResultCodeEnum,
} from '@shipstation/financial-services-ui-components';
import { Modal, Utils } from 'common';
import React, { useContext } from 'react';
import APapiConfig from './APapiConfig';

const { Session: SdcSession, Util } = Utils;
const { ModalContext } = Modal;

const PBBRedirectHandler = () => {
	const { customerId } = SdcSession.getAccountInfo();

	const { showError } = useContext(ModalContext);

	const pbbCompleteCallback = ({ resultCode }) => {
		const success = resultCode === ResultCodeEnum.Authorised;

		// remove query params from URL
		Util.removeQueryParamByName(['sessionId', 'redirectResult']);

		if (!success) {
			return showError({
				data: {
					title: 'Error',
					description: resultCode,
					primaryButtonText: 'Close',
					handleType: 'custom',
				},
			});
		}
	};

	const getAPConfig = () => APapiConfig.getAPConfig({ customerId });

	const auctanePayConfig = {
		getConfig: getAPConfig,
	};

	return (
		<FinancialServicesUIProvider
			apiConfig={auctanePayConfig}
			locale="en"
			useMantine={true}
		>
			<RedirectHandler onPaymentCompleted={pbbCompleteCallback} />
		</FinancialServicesUIProvider>
	);
};

export default PBBRedirectHandler;
